import { useFormik } from 'formik';
import { bool, func } from 'prop-types';
import React from 'react';
import * as Yup from 'yup';

import ModalComponent from '@components/Share/ModalComponent';
import { Text } from '@sitecore-jss/sitecore-jss-react';

import useSelectStoreAndDateContext from '../../../useSelectStoreAndDateContext';
import AreaSelect from './AreaSelect';

const FilterPopup = ({ showFilter, onCloseFilterPopup, onFilter, onClearFilter }) => {
  const { layoutData } = useSelectStoreAndDateContext();

  const formik = useFormik({
    initialValues: {
      area: null
    },
    validationSchema: Yup.object({
      area: Yup.object()
        .shape({
          label: Yup.string().required(layoutData?.pleaseEnterAreaLabel?.value || layoutData?.['Please Enter Area Label']?.value),
          value: Yup.string().required(layoutData?.pleaseEnterAreaLabel?.value || layoutData?.['Please Enter Area Label']?.value)
        })
        .typeError(layoutData?.pleaseEnterAreaLabel?.value || layoutData?.['Please Enter Area Label']?.value)
    }),
    onSubmit: (values) => {
      onFilter(values);

      onCloseFilterPopup();
    }
  });

  const handleClearFilter = () => {
    formik.resetForm();

    onCloseFilterPopup();

    onClearFilter();
  };

  return (
    <ModalComponent
      isShow={showFilter}
      titlePopup={layoutData?.filterStoresLabel?.value || layoutData?.['Filter Stores Label']?.value}
      onCloseHandler={onCloseFilterPopup}
      cssClass='search-filter-bar__filter-popup'
    >
      <div className='address-component'>
        <form onSubmit={formik.handleSubmit} className='store-locator__modal'>
          <div className='user-addresses'>
            <div className='form-group form-group--select'>
              <AreaSelect value={formik.values.area} onChange={(selected) => formik.setFieldValue('area', selected)} />
              {formik.errors.area && formik.touched.area && <span className='error-validate'>{formik.errors.area}</span>}
            </div>
          </div>
          <div className='button-container'>
            <button className='btn btn-primary' type='submit'>
              <Text field={layoutData?.applyFiltersButtonLabel || layoutData?.['Apply Filters Button Label']} />
            </button>
            <Text
              className='btn-clear-filter'
              field={layoutData?.clearFiltersButtonLabel || layoutData?.['Clear Filters Button Label']}
              tag='span'
              onClick={handleClearFilter}
            />
          </div>
        </form>
      </div>
    </ModalComponent>
  );
};

FilterPopup.propTypes = {
  showFilter: bool,
  onCloseFilterPopup: func,
  onFilter: func,
  onClearFilter: func
};

export default FilterPopup;
